module.exports = __webpack_public_path__ + "img/login_banner1.ac78e277.jpg";